import { typedHasOwnProperty, typedUnknownHasOwnProperty } from "./objectHelpers";
import { type ITaskStatuses, TaskStatuses } from "./types/ITrainPanelModelEl";

export const getPrivateMessageFromError = (e: unknown) => {
	let message = "";
	if (e === null) return "Unknown Error";
	if (typeof e === "string") return e;
	if (typeof e !== "object") return "Unknown Error";
	if (typedHasOwnProperty(e, "stack")) {
		message += e.stack;
	}
	return message + e.toString();
};

export const isAbortError = (e: unknown): e is Error => {
	return typedUnknownHasOwnProperty(e, "name") && e.name === "AbortError";
};

export const getPublicMessageFromError = (e: unknown) => {
	const message = "";
	if (e === null) return null;
	if (typeof e === "string") return e;
	if (typeof e !== "object") return null;
	return message + e.toString();
};

export const getMessageAccordTaskStatus = (e: ITaskStatuses | string) => {
	switch (e) {
		case TaskStatuses.Error:
			console.log("Task Status: ERROR");

			return `Please reload the page to make sure you're using the up-to-date version. If the error keeps appearing, use Bug report feature in the right down page corner`;
		case TaskStatuses.Error_params:
			console.log("Task Status: ERROR");
			return `Please reload the page to make sure you're using the up-to-date version. If the error keeps appearing, use Bug report feature in the right down page corner`;

		case TaskStatuses.Canceled:
			console.log("Task Status: CANCELED");
			return "Error while creating task, please restart generation";

		case TaskStatuses.Error_exec_timeout:
			console.log("Task Status: Error exec timeout");
			return "Looks like your generation took too long. You may be in a service queue. Please try again, or try lowering the input/output size or quality.";

		case TaskStatuses.Error_cuda:
			console.error("Task Status: Cuda error");
			return `Can't get memory for processing. May be too many tasks are now run at the same time, just try to relaunch this node in a sec.`;
		default:
			return null;
	}
};

export const isCancelError = (e: unknown) => {
	return typeof e === "object" && e !== null && "code" in e && (e as any).code === "ERR_CANCELED";
};
